import { isEmpty } from "lodash";
import React, { useState, useContext, useRef, useEffect } from "react";
import { Form, Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { Link } from "react-router-dom";
import AuthProvider from "../context/AuthContext";
import { apiGet } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import Aboutus from "../components/staticContent/Aboutus";
import GeneralTerms from "../components/staticContent/GeneralTerms";
import Kyc from "../components/staticContent/Kyc";
import PrivacyPolicy from "../components/staticContent/PrivacyPolicy";
import RulesRegulation from "../components/staticContent/RulesRegulation";
import ResponsibleGaming from "../components/staticContent/ResponsibleGaming";
import { AiFillEye, AiFillEyeInvisible } from "react-icons/ai";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import { IoIosRefresh } from "react-icons/io";
import { MdRefresh } from "react-icons/md";
import LoadingPage from "../components/loader/LoadingPage";
import Tab from "../components/socialTab/tab";

function Login(props) {
  let { loginUser, isLoged } = useContext(AuthProvider);
  const {
    register: register2,
    handleSubmit: handleSubmit2,
    formState: { errors: errors2 },
    unregister,
    reset: reset2,
  } = useForm({
    defaultValues: {
      username: "",
      password: "",
      uniqueId: Math.random() * 10000,
    },
  });

  const [passwordType, setPasswordType] = useState("password");
  const togglePassword = (e) => {
    e.preventDefault()
    if (passwordType === "password") {
      setPasswordType("text")
      return;
    }
    setPasswordType("password")
  }

  const [getValidateCode, setValidateCode] = useState("");
  const [loading, setLoading] = useState(false);
  let { open, setOpen, content, slug, setSlug, handleContentToggle } =
    useContext(AuthProvider);

  const [data, setData] = useState({});
  const onSubmit2 = (data) => {
    // if (parseInt(data.validateCode) !== parseInt(getValidateCode)) {
    //   changeCode();
    //   reset2({ validateCode: "" });
    //   setLoading(false);
    // }
    if (parseInt(data.validateCode) === parseInt(getValidateCode)) {
      setLoading(true);
      loginUser(data);
      setLoading(false);
    }
  };
  const canvasRef = useRef(null);
  const changeCode = () => {
    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");
    context.font = "bold 120px sans-serif";
    const code = Math.floor(1000 + Math.random() * 9000);
    context.clearRect(0, 0, canvas.width, canvas.height);
    context.fillText(code, 0, 130);
    setValidateCode(code);
  };

  const getSetting = async (event) => {
    try {
      const { status, data: response_users } = await apiGet(apiPath.getSetting);
      if (status === 200) {
        if (response_users.success) {
          setData(response_users.results);
        }
      }
    } catch (err) { }
  };
  useEffect(() => {
    changeCode();
    getSetting();
  }, []);

  useEffect(() => {
    if (isLoged === "failed") {
      changeCode();
      reset2({
        validateCode: ""
      });
      setLoading(false);
    }
  }, [isLoged]);

  // const [activeLink, setActiveLink] = useState('https://wa.me/+19146393028');

  // const handleSocialClick = (link, e) => {
  //   e.preventDefault();
  //   setActiveLink(link);
  // };

  // const handleActiveLinkClick = () => {
  //   if (activeLink) {
  //     window.open(activeLink.trim(), '_blank');
  //   }
  // };


  return (
    <>
    <div className="">
      <div className="login_main">
        <header className="login-head" style={{ position: 'relative' }}>
          <Link to="/" className="close"></Link>
          <h1 style={{ backgroundSize: "contain" }}></h1>

          {/* Bottom middle overlay image */}
          {/* <div
            style={{
              position: 'absolute',
              bottom: '30px',
              left: '50%',
              transform: 'translateX(-50%)',
              zIndex: 10,
              filter: 'brightness(1)',
              color: '#a6a6a6' // darker grey
            }}
          >
            <span
              style={{
                fontSize: '12px',
                marginLeft: '0px',
                display: 'block',
                textAlign: 'center'
              }}
            >
              Powered By
            </span>

            <img
              src="/download.png"
              alt="Logo"
              style={{
                width: '130px',
                height: 'auto',
                display: 'block',
                margin: '0 auto',
                filter: 'invert(1)'
              }}
            />
          </div> */}


          {/* <div id="powerWrap" className="betfair-wrap">
            <p>Powered by</p>
            <span>
              <img
                src={
                  import.meta.env.VITE_MOBILE_URL +
                  "/assets/images/betfair_black.png"
                }
                alt=""
                draggable="false"
              />
            </span>
          </div> */}
        </header>
        <Form onSubmit={handleSubmit2(onSubmit2)}>
          <dl className="form-login">
            <Form.Group
              style={{ marginBottom: "10px" }}
              id="loginNameErrorClass"
            >
              <Form.Control
                type="text"
                autoComplete="off"
                // id="loginName"
                className={errors2.username ? "is-invalid" : ""}
                {...register2("username", {
                  required: "Please enter Username",
                })}
                placeholder="Username"
              />
              {errors2.username && errors2?.username?.message && (
                <label className="invalid-feedback text-left">
                  {errors2.username.message}
                </label>
              )}
            </Form.Group>
            <Form.Group
              style={{ marginBottom: "10px" }}
              id="passwordErrorClass"
            >
              <div style={{ position: 'relative' }}>
                <Form.Control
                  type={passwordType ? passwordType : "password"}
                  autoComplete="off"
                  // id="password"
                  className={errors2.password ? "is-invalid" : ""}
                  {...register2("password", {
                    required: "Please enter password",
                  })}
                  data-role="none"
                  placeholder="Password"
                />
                <div className="input-group-btn" style={{ position: 'absolute', right: '0', top: '0', bottom: '0px' }}>
                  <span className="btn btn-outline-primary" onClick={togglePassword} style={{ backgroundColor: 'transparent', backgroundImage: `none`, border: '0', padding: '8px 6px', paddingTop: '3px', height: '100%', paddingBottom: '0', fontSize: `6.5vw`, lineHeight: `1.8`, display:'flex', alignItems:'center', justifyContent:'center' }}>
                    {passwordType === "password" ? <AiFillEyeInvisible /> : <AiFillEye />}
                  </span>
                </div>
              </div>
              {errors2.password && errors2.password.message && (
                <label className="invalid-feedback text-left">
                  {errors2.password.message}
                </label>
              )}
            </Form.Group>
            <dd id="validCodeErrorClass" style={{ display: "block" }}>
              <input
                type="number"
                keyboardType="numeric"
                autocomplete="off"
                maxLength="4"
                className={errors2.validateCode ? "is-invalid" : ""}
                {...register2("validateCode", {
                  required: "Please enter validate code",
                  validate: {
                    validate: (value) =>
                      parseInt(value) === parseInt(getValidateCode) ||
                      "Invalid validate code",
                  },
                })}
                onChange={(e) => {
                  if (e.target.value.length == 4) {
                    e.target.blur();
                    unregister("validateCode", { keepValue: true });
                  }
                }}
               
                id="validCode"
                placeholder="Validation Code"
               
              />
              
              <canvas
                ref={canvasRef}
                onClick={changeCode}
                className="inputcanvas"
                id="authenticateImage"
              />

              {errors2.validateCode && errors2.validateCode.message && (
                <label className="invalid-feedback text-left" style={{color: '#ee4136'}}>
                  {errors2.validateCode.message}
                </label>
              )}
            </dd>
            {/* <dd>
              <input name="valid" type="hidden" id="valid" />
            </dd> */}
            {/* <div className=""
              style={{ textAlign: 'right', color: '#fff', marginBottom: '12px' }}>
              <Link to="/change-password">Change Password</Link>
            </div> */}
            <dd style={{}}>
              <Button type="submit" className="btn-send w-100" id="loginBtn">
                Login
              </Button>
            </dd>
            {isLoged == "failed" && (
              <dd id="errorMsg" class="state">
                Login name or password is invalid! Please try again.
              </dd>
            )}
          </dl>
        </Form>

        <div className="newcssadd">

          <ul className="login-policy policy-link home-link">
            
            <li>
              <Link
                to="javascript:void(0)"
                onClick={() => {
                  handleContentToggle();
                  setSlug("about");
                }}
              >
                About us
              </Link>
            </li>
            <li>
              <Link
                to="javascript:void(0)"
                onClick={() => {
                  handleContentToggle();
                  setSlug("term");
                }}
              >
                Terms and Conditions
              </Link>
            </li>
            <li>
              <Link
                to="javascript:void(0)"
                onClick={() => {
                  handleContentToggle();
                  setSlug("kyc");
                }}
              >
                KYC
              </Link>
            </li>
            <li>
              <Link
                to="javascript:void(0)"
                onClick={() => {
                  handleContentToggle();
                  setSlug("privacy");
                }}
              >
                Privacy Policy
              </Link>
            </li>

            
            <li>
              <Link
                to="javascript:void(0)"
                onClick={() => {
                  handleContentToggle();
                  setSlug("rules");
                }}
              >
                Rules and Regulations
              </Link>
            </li>
            
            <li>
              <Link
                to="javascript:void(0)"
                onClick={() => {
                  handleContentToggle();
                  setSlug("responsible");
                }}
              >
                Responsible Gaming
              </Link>
            </li>
            {/* <li>
              <Link
                to="javascript:void(0)"
                onClick={() => {
                  handleContentToggle();
                  setSlug("rules");
                }}
              >
                Underage Gaming Policy
              </Link>
            </li> */}

            {/* <li>
              <a href="#">Self-Exclusion Policy</a>
            </li> */}

          </ul>

          <div id="supportWrap" className="support-wrap support-wrap-login" style={{marginBottom:'20px', position: 'relative'}}>
            <div className="" style={{paddingBottom:'10px', position: 'relative', display:'flex', gap:'25px', justifyContent:'center'}}>
             
                  <Tab/>
                </div>
           
            
            {/* Arrow element - dynamically positioned */}
            {/* {activeLink && (
              <div style={{
                position: 'absolute',
                bottom: '-15px',
                left: activeLink.includes("wa.me") ? 'calc(50% - 32.5px)' : 'calc(50% + 32.5px)',
                width: '0',
                height: '0',
                borderLeft: '10px solid transparent',
                borderRight: '10px solid transparent',
                borderTop: '15px solid white',
                transform: 'translateX(-50%)',
                transition: 'left 0.3s ease'
              }}></div>
            )} */}
            
            {/* Clickable link display */}
            {/* {activeLink && (
              <div 
                onClick={handleActiveLinkClick}
                style={{
                  textAlign: 'center',
                  marginTop: '20px',
                  fontSize: '12px',
                  cursor: 'pointer',
                  textDecoration: 'underline',
                  color: 'white'
                }}
              >
                {activeLink.includes("wa.me") 
                  ? "" 
                  : "#"}
              </div>
            )} */}
          </div>


          {content && (
            <div className="frame-wrap">
              <div className="news-wrap news-wrap-frame">
              {slug === "about" && <Aboutus />}
              {slug === "term" && <GeneralTerms />}
              {slug === "kyc" && <Kyc />}
              {slug === "privacy" && <PrivacyPolicy />}
              {slug === "rules" && <RulesRegulation />}
              {slug === "responsible" && <ResponsibleGaming />}

              <footer>
                <Link
                  to="#"
                  className="btn-send"
                  onClick={() => {
                    handleContentToggle();
                    setSlug("");
                  }}
                >
                  CLOSE
                </Link>
              </footer>
            </div>
            </div>
          )}

          {/* static-content */}

        </div>

        </div>
      </div>
      {loading && <LoadingPage />}
      </>
  );
}

export default Login;